import metaData, { urlJourneyConfigMapping } from "@utils/metaData";
import { getNewCarMetaData } from "@components/car/journey/common/utils";
import { checkIfBikeJourney } from "@renewals/util";
import {} from "utils/getHelpData";

export const getHelpData = ({ query, pathname, isMobile }) => {
  const { cardType, step, product: autoProduct } = query;

  let showHelp = false;
  let helpData: any = { screen: "" };
  let floatingCallbackCtaStyles = {};
  let showBackNavigator = true;
  let showChatbot = false;

  if (pathname?.includes("/car-journey/")) {
    showHelp = true;
    showChatbot = true;
    if (pathname?.includes("/car-journey/[cardType]")) {
      const cardUrl = cardType.toString();
      const pageCardType = urlJourneyConfigMapping[cardUrl];
      let analyticsScreen;
      if (cardUrl !== "nsr") {
        analyticsScreen = metaData
          ? metaData[pageCardType]?.analyticsScreen
          : "";
      }
      helpData = { screen: analyticsScreen, showFloatingCallbackCta: true };
      floatingCallbackCtaStyles = {
        zIndex: 10,
        ...(isMobile && { marginBottom: "24px" })
      };
    } else if (pathname?.includes("/car-journey/plans")) {
      helpData = {
        screen: "plans",
        showFloatingCallbackCta: true
      };
      floatingCallbackCtaStyles = { bottom: isMobile ? "148px" : "124px" };
    } else if (pathname?.includes("/car-journey/plan-details")) {
      helpData = {
        screen: "addons",
        showFloatingCallbackCta: true
      };
    } else if (pathname?.includes("/car-journey/checkout")) {
      let analyticsScreen = "";
      switch (step) {
        case "details": {
          analyticsScreen = "checkout-screen";
          break;
        }
        case "verify-otp": {
          analyticsScreen = "";
          break;
        }
        case "review": {
          analyticsScreen = "review-screen";
          break;
        }
        default: {
          break;
        }
      }
      helpData = { screen: analyticsScreen, showFloatingCallbackCta: true };
      floatingCallbackCtaStyles = { bottom: "15%" };
    }
  } else if (pathname?.includes("/new-car/")) {
    showHelp = true;
    if (pathname?.includes("/new-car/[cardType]")) {
      const metaData = getNewCarMetaData();
      const cardUrl = cardType.toString();
      const pageCardType = urlJourneyConfigMapping[cardUrl];
      const analyticsScreen = metaData[pageCardType]?.analyticsScreen;
      helpData = {
        screen: analyticsScreen,
        showFloatingCallbackCta: true
      };
      floatingCallbackCtaStyles = {
        ...(isMobile && { marginBottom: "6px" })
      };
    } else if (pathname?.includes("/new-car/plans")) {
      helpData = { screen: "plans", showFloatingCallbackCta: true };
      floatingCallbackCtaStyles = { bottom: "124px" };
    } else if (pathname?.includes("/new-car/details")) {
      helpData = { screen: "new_car_details" };
    } else if (pathname?.includes("/new-car/plan-details")) {
      helpData = { screen: "plan_details" };
    } else if (pathname?.includes("/new-car/checkout")) {
      let pageScreen = "";
      switch (step) {
        case "details": {
          pageScreen = "checkout-screen";
          break;
        }
        case "verify-otp": {
          pageScreen = "";
          break;
        }
        case "review": {
          pageScreen = "review-screen";
          break;
        }
      }
      helpData = { screen: pageScreen, showFloatingCallbackCta: true };
      floatingCallbackCtaStyles = { bottom: "15%" };
    }
  } else if (pathname?.includes("/renew-policy/")) {
    helpData = { screen: "renewal_plans", showFloatingCallbackCta: true };
    showHelp = !checkIfBikeJourney(autoProduct);
    if (pathname?.includes("/renew-policy/plan-selection")) {
      showBackNavigator = false;
      helpData = { showFloatingCallbackCta: false };
    } else if (pathname?.includes("/renew-policy/checkout")) {
      helpData = {
        screen: "renewal_review_screen",
        showFloatingCallbackCta: true
      };
    } else if (pathname?.includes("/renew-policy/plan-details")) {
      helpData = {
        screen: "renewal_review_screen",
        showFloatingCallbackCta: true
      };
    } else if (pathname?.includes("/renew-policy/auto-renew")) {
      helpData = {};
      showHelp = false;
    } else if (pathname?.includes("/renew-policy/edit")) {
      helpData = {
        screen: "renewal_review_screen"
      };
      showHelp = false;
    } else if (pathname?.includes("/renew-policy/edit/selection")) {
      helpData = {
        screen: "renewal_review_screen",
        showFloatingCallbackCta: true
      };
      showHelp = false;
    } else if (pathname?.includes("/renew-policy/edit/confirm")) {
      helpData = {
        screen: "renewal_review_screen"
      };
      showHelp = !checkIfBikeJourney(autoProduct);
    }
  } else if (pathname?.includes("/inspection/")) {
  } else if (pathname?.includes("/payment-success-kyc/")) {
  } else if (pathname?.includes("/bike-journey/")) {
  }

  return {
    helpData,
    showHelp,
    floatingCallbackCtaStyles,
    showBackNavigator,
    showChatbot
  };
};
